/** Owns one pointer drag and releases its document listeners and body styles. */
export function beginPointerResize({
  onResize,
  onEnd,
}: {
  onResize: (event: PointerEvent) => void;
  onEnd: () => void;
}): () => void {
  const previousCursor = document.body.style.cursor;
  const previousSelection = document.body.style.userSelect;
  let ended = false;
  const stop = () => {
    if (ended) return;
    ended = true;
    document.removeEventListener('pointermove', onResize);
    document.removeEventListener('pointerup', stop);
    document.removeEventListener('pointercancel', stop);
    window.removeEventListener('blur', stop);
    document.body.style.cursor = previousCursor;
    document.body.style.userSelect = previousSelection;
    onEnd();
  };
  document.body.style.cursor = 'col-resize';
  document.body.style.userSelect = 'none';
  document.addEventListener('pointermove', onResize);
  document.addEventListener('pointerup', stop);
  document.addEventListener('pointercancel', stop);
  window.addEventListener('blur', stop);
  return stop;
}

/**
 * The box a percentage width resolves against: the nearest ancestor that renders one. A
 * `display: contents` wrapper has no box (its rect is all zeros), so it is skipped.
 */
export function layoutContainer(element: Element): Element | null {
  let parent = element.parentElement;
  while (parent !== null && getComputedStyle(parent).display === 'contents') {
    parent = parent.parentElement;
  }
  return parent;
}
